<template>
  <el-select
    v-model="clientsModel"
    @change="clientsChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.CLIENTS')"
    :filterable="true"
    :multiple="true"
    :disabled="disabled"
    remote
    :remote-method="getClients"
    :loading="loading"
  >
    <el-option
      v-for="client in clientsList"
      :key="client.id"
      :value="client.id"
      :label="`${client.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { difference } from "lodash";
import { Option, Select } from "element-ui";

export default {
  name: "clients-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    clients: {
      type: Array,
      default: () => [],
      description: "Clients",
    },
  },

  data() {
    const clientsModel = this.clients?.map((item) => item.id) ?? [];
    return {
      clientsModel,
      clientsList: {},
      loading: false,
    };
  },

  setup() {},

  created() {
    this.getClients(null, this.clients);
  },

  methods: {
    async getClients(query = null, clients = null) {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {
            ...(query ? { search: query } : {}),
            ...(clients ? { with_ids: clients.map((item) => item.id) } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };
        await this.$store.dispatch("clients/list", params);
        const clientsArr = await this.$store.getters["clients/list"];
        this.clientsList = {};
        clientsArr.forEach((client) => {
          this.clientsList[client.id] = client;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async clientsChanged(clients) {
      this.$emit(
        "clientsChanged",
        [...clients].map((item) => ({ type: "clients", id: item }))
      );
    },
  },

  watch: {
    clients(clients) {
      if (clients && clients.length != 0) {
        const clientsData = clients.map((item) => item.id);
        if (difference(clientsData, this.clientsModel).length !== 0) {
          this.clientsModel = clientsData;
          this.getClients(null, clients);
        }
      } else {
        this.clientsModel = [];
      }
    },
  },
};
</script>
